import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPpday75 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_75: Record<
  Exclude<PageIdWoofzPpday75, PageIdWoofzPpday75.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PPDAY_75_N]: {
    id: PageId.SUBSCRIPTIONS_PPDAY_75_N,
  },
  [PageId.CHAT_UPSELL_PPDAY_75]: {
    id: PageId.CHAT_UPSELL_PPDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PPDAY_75]: {
    id: PageId.UPSELL_PPDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_PPDAY_75]: {
    id: PageId.DOWNLOAD_PPDAY_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
